import React from 'react';
import PropTypes from 'prop-types';

import {
    Attachment as StyledAttachment,
    Content as StyledContent,
    Name as StyledName,
} from './styles';
import ItemIcon from 'components/Icons';

const joinClasses = (...classes) => [...classes].join(' ').trim();

const Attachment = ({ children, className, textBoxRef, ...otherProps }) => {
    const classNames = joinClasses('item-wrapper', className);

    return (
        <StyledAttachment className={classNames} ref={textBoxRef} {...otherProps}>
            {children}
        </StyledAttachment>
    );
};

Attachment.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    textBoxRef: PropTypes.object
};

Attachment.Icon = ItemIcon;

Attachment.Content = ({ children, className, ...otherProps }) => {
    const classNames = joinClasses('item-content', className);

    return (
        <StyledContent className={classNames} {...otherProps}>
            {children}
        </StyledContent>
    );
};

Attachment.Content.displayName = 'Attachment.Content';
Attachment.Content.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

Attachment.Name = ({ children = null, className, ...restProps }) => {
    const classNames = joinClasses('item-name', className);

    return (
        <StyledName className={classNames} {...restProps}>
            {children}
        </StyledName>
    );
};

Attachment.Name.displayName = 'Attachment.Name';
Attachment.Name.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default Attachment;
